
<div class="subheader with-padding flgrow">
        <div class="row align-items-center">
         <div class='col-lg-4 col-md-4 col-sm-8'>
            <ng-select placeholder="{{ 'lblVersionNumber' | translate }}" [(ngModel)]="selectedVersionNumber">
                <ng-option *ngFor="let versionNumber of versionNumberList" [value]="versionNumber.value" >
                      {{versionNumber.name}}
                </ng-option>
            </ng-select>
        </div>
        <div class="col-auto">
                <button type="button" class="add-button btn btn-primary" aria-label="Center Align" translate (click)="VersionNumberChange()">lblSearch</button>
            </div>
        <div class="col-auto ml-auto" *ngIf="userRoleRightsDetails.canAdd">
                <button type="button" class="add-button btn btn-primary" aria-label="Center Align" translate
                  (click)="onAdd()">lblAddVersion</button>
              </div>
        </div>
    </div>
    <div class="container-fluid prel">
        <div class="row">
            <div class="col-12">
                <div class="card mb-3">
                    <div class="card-header d-flex">
                        <h4 class="card-title" translate>lblApplicationVersionDetails</h4>
                    </div>
                    <div class="table-responsive">
    
    
                        <table class="tablest1">
                            <thead>
                                <tr>
                                    <th  scope="col">#</th>
                                    <th  scope="col" sortable="versionNumber" (sort)="onSort($event)" translate>lblVersionNumber</th>
                                    <th scope="col" sortable="createdDate" (sort)="onSort($event)" translate>lblCreatedDate
                                    </th>
                                    <th  scope="col" sortable="updatedDate" (sort)="onSort($event)" translate>lblUpdatedDate</th>
                                    <th style="width: 5%" scope="col" translate>lblAction</th>
                                </tr>
                            </thead>
                            <tbody>
                                <ng-container *ngIf="applicationVersionList?.length>0; else load_else">
                                    <tr *ngFor="let applicationVersion of applicationVersionList; let i=index">
                                        <td>{{ applicationVersion.RowId }}</td>
                                        <td>
                                            <ngb-highlight [result]="applicationVersion.versionNo"></ngb-highlight>
                                        </td>
                                        <td>
                                             <ngb-highlight  [result]="applicationVersion.createdDate | date:'short'"></ngb-highlight> 
                                            
                                        </td>
                                        <td>
                                            <ngb-highlight  [result]="applicationVersion.updatedDate | date:'short'"></ngb-highlight> 
                                            
                                        </td>
                                        <td class="nowrap text-center">
                                            <a class="btn btn-ico"  ngbTooltip="{{'lblEdit' | translate}}" tooltipClass="custom-revert" (click)="onEdit(applicationVersion.id)" *ngIf="userRoleRightsDetails.canEdit">
                                                <em class="fas fa-pencil-alt fa-lg"></em>
                                            </a>

                                        </td>
                                    </tr>
                                </ng-container>
                                <ng-template #load_else>
                                    <tr>
                                        <td colspan="8" class="no-record" translate>lblNoRecordsFound</td>
                                    </tr>
                                </ng-template>
                            </tbody>
                        </table>
                    </div>
                    <div class="card-footer">
                        <div class="d-flex justify-content-between">
                            <div class="d-flex justify-content-between">
                                <ngb-pagination [collectionSize]="pService.total$  | async" [(page)]="pService.page" [pageSize]="pService.pageSize" [maxSize]="3">
                                </ngb-pagination>
                                <select class="custom-select mx-2" style="width: auto" name="pageSize" [(ngModel)]="pService.pageSize">
                    <option *ngFor="let item of pService.pageItemsArray" [ngValue]="item.values" translate>{{item.label}}
                    </option>
                  </select>
                            </div>
                            <div class="d-flex justify-content-between p-2 font17 fontbold" style="margin: auto 0;">
                                <span class="font17 fontnormal" translate>lblTotal</span>:&nbsp;{{pService.total$ | async}}&nbsp;<span class="font17 fontnormal" translate>lblResults</span>
                            </div>
    
                        </div>
                    </div>
                </div>
    
            </div>
        </div>
    
    </div>
 
  
